<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 700" id="animals">
    <path id="path5419" d="M578.3,533.1v-16.3l-34.1,4.7L578.3,533.1z" />
    <path id="path4232" d="M578.3,533.1l-24.2,26.8l-9.9-38.3L578.3,533.1z" />
    <path id="path4236" d="M507.7,578.2l46.4-18.4l-9.9-38.3L507.7,578.2z" />
    <path id="path4240" d="M507.7,578.2l18.9-53.3l17.6-3.5L507.7,578.2z" />
    <path id="path4244" d="M548.1,466.9l-21.5,58l17.6-3.5L548.1,466.9z" />
    <path id="path4248" d="M548.1,466.9l-21.5,58l-30.2-25.7L548.1,466.9z" />
    <path id="path4252" d="M507.7,578.2l18.9-53.3l-31-27.5L507.7,578.2z" />
    <path id="path4628" d="M548.1,466.9l-64.3-49.7l12.6,82L548.1,466.9z" />
    <path id="path4632" d="M507.7,578.2l-24.2-0.6l12-80.3L507.7,578.2z" />
    <path id="path4634" d="M548.1,466.9l-64.3-49.7l48.6-17.2L548.1,466.9z" />
    <path id="path4636" d="M462.7,480l21.2-62.7l12.6,82L462.7,480z" />
    <path id="path4644" d="M438.2,512.2l45.2,65.6l12-80.3L438.2,512.2z" />
    <path id="path4646" d="M438.2,512.2l23-32.2l34.3,17.4L438.2,512.2z" />
    <path id="path4648" d="M438.2,512.2l45.2,65.6L402.3,558L438.2,512.2z" />
    <path id="path4656" d="M392.2,592.3l91.3-14.7l-81.1-19.7L392.2,592.3z" />
    <path id="path4658" d="M392.2,592.3l-49.1-31l59.2-3.5L392.2,592.3z" />
    <path id="path4660" d="M392.2,592.3l-49.1-31L322.1,584L392.2,592.3z" />
    <path id="path4662" d="M438.2,512.2l-32,11.4l-3.9,34.5L438.2,512.2z" />
    <path id="path4672" d="M350.6,550l55.6-26.6l-3.9,34.5L350.6,550z" />
    <path id="path4674" d="M350.6,550l55.6-26.6l-63.3,8.5L350.6,550z" />
    <path id="path4676" d="M375.1,518.9l31.1,4.7l-63.3,8.5L375.1,518.9z" />
    <path id="path4678" d="M375.1,518.9l31.1,4.7l-37.3-25L375.1,518.9z" />
    <path id="path4688" d="M437.5,511.4l-31.2,12l-37.3-24.9L437.5,511.4z" />
    <path id="path4690" d="M437.5,511.4l23.7-31l-92.3,18.1L437.5,511.4z" />
    <path id="path4692" d="M414.5,461.7l46.8,18.8l-92.4,18.1L414.5,461.7z" />
    <path id="path4694" d="M414.5,461.7l46.8,18.8l22-62.8L414.5,461.7z" />
    <path id="path4704" d="M500.6,363.6l-16.8,53.6l48.6-17.2L500.6,363.6z" />
    <path id="path4706" d="M500.6,363.6l-16.8,53.6l-48.7-37.9L500.6,363.6z" />
    <path id="path4708" d="M415.2,460.2l68.7-43l-48.7-37.9L415.2,460.2z" />
    <path id="path4729" d="M500.6,363.6l-34.5-42.2l-31,57.8L500.6,363.6z" />
    <path id="path4731" d="M398.1,299.9l68,21.5l-31,57.8L398.1,299.9z" />
    <path id="path4733" d="M398.1,299.9l-44.2,103.4l81.3-23.9L398.1,299.9z" />
    <path id="path4735" d="M415.2,464.6l-61.3-61.5l81.3-23.9L415.2,464.6z" />
    <path id="path4743" d="M415.2,464.6l-61.3-61.5l12.9,92.7L415.2,464.6z" />
    <path id="path4747" d="M301.5,490.7l52.4-87.5l12.9,92.7L301.5,490.7z" />
    <path id="path4749" d="M301.5,490.7l52.4-87.5l-50.3-20.1L301.5,490.7z" />
    <path id="path4755" d="M398.1,299.9l-44.2,103.4l2.5-67.7L398.1,299.9z" />
    <path id="path4757" d="M303,382.2l50.9,20.9l2.5-67.7L303,382.2z" />
    <path id="path4776" d="M301.5,490.7l-27-87.5l29.2-20.1L301.5,490.7z" />
    <path id="path4778" d="M303,382.2l-11.5-86.8l64.9,40L303,382.2z" />
    <path id="path4780" d="M225.8,372.6l48.7,30.5l29.2-20.1L225.8,372.6z" />
    <path id="path4799" d="M225.8,372.6l48.7,30.5l-67.4,49.7L225.8,372.6z" />
    <path id="path4801" d="M231.8,483.2l42.7-80.1l-67.4,49.7L231.8,483.2z" />
    <path id="path4818" d="M231.8,483.2l42.7-80.1l26.2,88.3L231.8,483.2z" />
    <path id="path4820" d="M231.8,483.2l25.6,32.1l43.3-23.9L231.8,483.2z" />
    <path id="path4822" d="M248,564.2l9.3-48.9l43.3-23.9L248,564.2z" />
    <path id="path4824" d="M231.8,483.2l25.6,32.1l-42.8,25.1L231.8,483.2z" />
    <path id="path4858" d="M233.2,553.1l24.2-37.8l-42.8,25.1L233.2,553.1z" />
    <path id="path4860" d="M232.5,553.1l24.9-37.8l-10.2,48.9L232.5,553.1z" />
    <path id="path4862" d="M226.1,563.9L215,600l32.2-35.8L226.1,563.9z" />
    <path id="path4864" d="M240.6,590.9l-25.6,9l32.2-35.8L240.6,590.9z" />
    <path id="path4866" d="M225.4,563.5L215,600l-22-9.8L225.4,563.5z" />
    <path id="path4878" d="M226.1,563.9l6.7-9.9l14.4,10.3L226.1,563.9z" />
    <path id="path4880" d="M226.1,563.9l6.7-9.9L216,540.4L226.1,563.9z" />
    <path id="path4961" d="M226.1,563.9l-38.7-12.9l28.5-10.5L226.1,563.9z" />
    <path id="path5128" d="M226.1,563.9L189,568l-1.2-16.4L226.1,563.9z" />
    <path id="path5130" d="M177.1,562.8l11.8,5.3l-1.2-16.4L177.1,562.8z" />
    <path id="path5136" d="M398.1,299.9l-50.9,0.8l9.2,34.8L398.1,299.9z" />
    <path id="path5138" d="M289.7,296.1l57.6,4.5l9.2,34.8L289.7,296.1z" />
    <path id="path5140" d="M303,382.2l-11.5-86.8l-68.1,77.2L303,382.2z" />
    <path id="path5142" d="M236.9,283.5l54.6,12l-68.1,77.2L236.9,283.5z" />
    <path id="path5144" d="M225.8,372.6l-42,0.8l23.3,79.3L225.8,372.6z" />
    <path id="path5166" d="M225.8,372.6l-42,0.8l22.5-61L225.8,372.6z" />
    <path id="path5168" d="M236.9,283.5l-32.3,31.4l18.8,57.8L236.9,283.5z" />
    <path id="path5170" d="M236.9,283.5l-32.3,31.4l-16-41.6L236.9,283.5z" />
    <path id="path5172" d="M184.1,377.8l20.5-63.1l-16-41.6L184.1,377.8z" />
    <path id="path5174" d="M184.1,377.8l-10.1-60.1l14.4-44.6L184.1,377.8z" />
    <path id="path5176" d="M157.4,255.9l16.8,61.8l14.4-44.6L157.4,255.9z" />
    <path id="path5186" d="M157.4,255.9l16.8,61.8l-52.5-47.6L157.4,255.9z" />
    <path id="path5188" d="M157.4,255.9l-34.6-20.7l-1.2,34.8L157.4,255.9z" />
    <path id="path5190" d="M157.4,255.9l-34.6-20.7l31.5-11.2L157.4,255.9z" />
    <path id="path5200" d="M157.4,255.9l30,14.2L154.3,224L157.4,255.9z" />
    <path id="path5202" d="M202.8,239.7l-15.2,30.5L154.5,224L202.8,239.7z" />
    <path id="path5204" d="M202.8,239.7l-7.8-39.3l-40.6,23.7L202.8,239.7z" />
    <path id="path5206" d="M202.8,239.7l-7.8-39.3l32.9,47.4L202.8,239.7z" />
    <path id="path5208" d="M202.8,239.7l-15.2,30.5l40.3-20.1L202.8,239.7z" />
    <path id="path5258" d="M202.8,239.7l-7.8-39.3l32.9,47.4L202.8,239.7z" />
    <path id="path5260" d="M247.3,200.3l-52.3,0.1l32.9,47.4L247.3,200.3z" />
    <path id="path5262" d="M236.2,282.7l-48.6-12.6l40.3-20.1L236.2,282.7z" />
    <path id="path5270" d="M236.2,282.7l49.4-41.9l-57.7,9.2L236.2,282.7z" />
    <path id="path5272" d="M236.2,282.7l49.4-41.9l4.3,54.8L236.2,282.7z" />
    <path id="path5286" d="M247.3,201.4l38.3,39.5l-57.7,9.2L247.3,201.4z" />
    <path id="path5288" d="M262.9,188.8l22.6,52.1l29.9-23.1L262.9,188.8z" />
    <path id="path5296" d="M304.2,189.2l38.3-0.6l-26.8,29.2L304.2,189.2z" />
    <path id="path5298" d="M304.2,189.2l-42.4,0.5l53.7,28.1L304.2,189.2z" />
    <path id="path5306" d="M304.2,189.2l38.3-0.6l-25.7-23.9L304.2,189.2z" />
    <path id="path5310" d="M344.3,173.1l-1.8,15.3l-25.7-23.9L344.3,173.1z" />
    <path id="path5316" d="M344.3,173.1l-4.8-14.7l-22.7,6.2L344.3,173.1z" />
    <path id="path5324" d="M262.9,188.8l22.6,52.1l29.9-23.1L262.9,188.8z" />
    <path id="path5341" d="M247,201.4l14.8-11.7l24.1,51.9L247,201.4z" />
    <path id="path5343" d="M304.2,189.2l-42.4,0.5l54.5-24.7L304.2,189.2z" />
    <path id="path5345" d="M286,135.3l-24.2,54.3l54.5-24.7L286,135.3z" />
    <path id="path5357" d="M286,135.3l42.7,10.2l-12.3,19.6L286,135.3z" />
    <path id="path5359" d="M286,135.3l42.7,10.2L315.2,100L286,135.3z" />
    <path id="path5361" d="M340.5,102.6l-11.8,42.8L315.2,100L340.5,102.6z" />
  </svg>
</template>

<script>
import rabbit from "@/data/rabbit";
import bird from "@/data/bird";
import deer from "@/data/deer";
import bear from "@/data/bear";
import dog from "@/data/dog";
export default {
  data() {
    return {
      count: 0,
      isPlaying: true,
      animationTimer: null,
      animalArray: [bear, deer, dog, bird, rabbit]
    };
  },
  methods: {
    async animateAnimal(animal) {
      const Snap = await import(
        "imports-loader?this=>window,fix=>module.exports=0!snapsvg/dist/snap.svg.js"
      );
      animal.forEach(path => {
        Snap.select(path.id).animate(
          {
            d: path.d
          },
          2000,
          window.mina.backout
        );
      });
    },
    animalAnimation() {
      var index = this.count % this.animalArray.length;
      this.animateAnimal(this.animalArray[index]);
      this.count++;
    },
    playAnimation() {
      clearInterval(this.animationTimer);
      this.animationTimer = setInterval(() => {
        this.animalAnimation();
      }, 3000);
    }
  },
  mounted() {
    this.playAnimation();
    window.addEventListener("scroll", () => {
      if (document.scrollingElement.scrollTop > this.$el.clientHeight) {
        clearInterval(this.animationTimer);
        this.isPlaying = false;
      } else {
        if (this.isPlaying) {
          return;
        }
        this.playAnimation();
      }
    });
  },
  beforeDestroy() {
    clearInterval(this.animationTimer);
  }
};
</script>

<style lang="scss" scoped>
svg {
  fill: none;
  stroke: $primary;
  stroke-miterlimit: 10;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
  width: 100%;
}
</style>
